module.exports = __webpack_public_path__ + "img/img-business-intelligence.86954174.webp";